/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorTranslationService } from './error-translation.service';
import { ErrorsService } from './errors.service';

export const skipErrorInterceptor = 'x-skip-error-interceptor';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private errorTranslationService: ErrorTranslationService, private errorsService: ErrorsService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    if (req.headers.has(skipErrorInterceptor)) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        catchError((err: HttpErrorResponse) => {
          this.errorsService.prepareAndSaveException(err, 'frontend', 'frontend');
          if(typeof err.error === 'string') {
            const jsonErr = JSON.parse(JSON.stringify(err))
            jsonErr.error = JSON.parse(err.error)
            err = jsonErr
          }
          if (err.status === 401) {
            return throwError(() => err);
          } else if (err.error?.message && err.error?.params) {
            this.errorTranslationService.translateAndShowParameterizedException(err);
          } else {
            if (err.error instanceof Blob) {
              err.error.text().then((errorMessage) => {
                const parsedError = JSON.parse(errorMessage);
                this.translateError(
                  parsedError.message,
                  parsedError.description,
                  parsedError.message,
                  parsedError.description
                );
              });
            } else {
              this.translateError(
                err.error?.message || err.error?.error,
                HttpErrorInterceptor.getDescriptionKeyFromErrorObject(err.error),
                err.message,
                err.error
              );
            }
          }
          return throwError(() => err);
        })
      );
    }
  }

  private static getDescriptionKeyFromErrorObject(error: any): string | string[] {
    return error?.description
      ? error.description
      : error?.fieldErrors
        ? error.fieldErrors.map((item: any) => item.message)
        : error?.error_description;
  }

  private translateError(
    message: string,
    description: string | string[],
    defaultMessage: string,
    defaultDescription: string
  ) {
    this.errorTranslationService.translateAndShowSimpleException(
      message,
      description,
      defaultMessage,
      defaultDescription
    );
  }
}
